import type { FeatureFlag } from '@core/domain';
import { useFeatureFlagContext } from '@core/providers/FeatureFlagProvider';

export function useIsFeatureEnabled(featureFlag: FeatureFlag): boolean {
  const { isFeatureEnabled } = useFeatureFlagContext();

  return isFeatureEnabled(featureFlag);
}
